module.exports = __webpack_public_path__ + "static/img/sixab.cdd11a69.png";